import React from 'react';
import { cn } from '@/lib/utils';
import { useChatShell, type AskMode } from '../ChatShellContext';

const ASK_MODES: { id: AskMode; label: string }[] = [
  { id: 'ai', label: 'AI' },
  { id: 'staff', label: 'Staff' },
  { id: 'community', label: 'Community' },
];

const ASK_MODE_HINT: Record<AskMode, string | null> = {
  ai: null,
  staff: 'The RCM team reads this and answers in the Library, typically within 24–48 hours.',
  community:
    'The RCM community reads this and answers in the Library. Timing depends on community engagement.',
};

/** Compact mode choices. Selected mode uses an indigo label and underline. */
export function AskModeSwitch() {
  const { askMode, setAskMode } = useChatShell();
  const hint = ASK_MODE_HINT[askMode];

  return (
    <div className="flex min-w-0 flex-col">
      <div className="flex items-center" role="group" aria-label="Ask mode">
        {ASK_MODES.map(({ id, label }) => {
          const active = askMode === id;
          return (
            <button
              key={id}
              type="button"
              aria-pressed={active}
              className={cn(
                'min-h-11 px-2.5 text-sm font-medium text-[var(--rcm-color-text-secondary)]',
                active &&
                  'text-[var(--rcm-color-primary)] shadow-[inset_0_-2px_0_var(--rcm-color-primary)]',
              )}
              onClick={() => setAskMode(id)}
            >
              {label}
            </button>
          );
        })}
      </div>
      {hint && <p className="px-2.5 pb-1 text-xs leading-relaxed text-muted-foreground">{hint}</p>}
    </div>
  );
}
